/*
  Gothic Lightbox — full-screen product image viewer.
  Tap/click a gallery image to open, swipe or use arrows to switch,
  X / Esc / backdrop-tap to close.
*/
(function () {
  function init(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.gothic-lightbox__slide'));
    if (!slides.length) return;

    var track = root.querySelector('[data-glb-track]');
    var currentEl = root.querySelector('[data-glb-current]');
    var sectionId = root.getAttribute('data-section-id');
    var scope = document.getElementById('shopify-section-' + sectionId) || document;
    var index = 0;

    function render() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      if (currentEl) currentEl.textContent = index + 1;
    }
    function go(i) {
      index = (i + slides.length) % slides.length;
      render();
    }
    function open(i) {
      go(i);
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gothic-lightbox-open');
    }
    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('gothic-lightbox-open');
    }

    // Open when a main gallery image is tapped/clicked.
    scope.addEventListener(
      'click',
      function (e) {
        var item = e.target.closest('.product__media-list .product__media-item');
        if (!item) return;
        var raw = item.getAttribute('data-media-id') || '';
        var mediaId = raw.split('-').pop();
        var i = -1;
        for (var s = 0; s < slides.length; s++) {
          if (slides[s].getAttribute('data-media-id') === mediaId) {
            i = s;
            break;
          }
        }
        if (i < 0) return; // not an image (video / 3d) — leave native behavior
        e.preventDefault();
        e.stopPropagation();
        open(i);
      },
      true
    );

    var prev = root.querySelector('[data-glb-prev]');
    var next = root.querySelector('[data-glb-next]');
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); go(index - 1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); go(index + 1); });

    Array.prototype.forEach.call(root.querySelectorAll('[data-glb-close]'), function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); close(); });
    });

    // Tap on the backdrop (not the image) closes.
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (
        t === root ||
        t.classList.contains('gothic-lightbox__viewport') ||
        t.classList.contains('gothic-lightbox__slide') ||
        t.classList.contains('gothic-lightbox__track')
      ) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(index + 1);
      else if (e.key === 'ArrowLeft') go(index - 1);
    });

    // Touch swipe navigation.
    var startX = 0, startY = 0, swiping = false;
    root.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      swiping = true;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
        go(index + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('[data-gothic-lightbox]').forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
